import { FC } from 'react';
import { LinkProps } from 'next/link';
import ExternalLink from './External-link';

export interface LocationAddressLinkType extends Omit<LinkProps, 'href'> {
	address: string;
}

const LocationAddressLink: FC<LocationAddressLinkType> = ({ address }) => (
	<ExternalLink
		href={`https://www.google.com/maps/search/${address?.replace(/\s/g, '+')}`}
		style={{
			color: 'inherit',
			textDecoration: 'inherit',
			textDecorationThickness: 'inherit',
			textUnderlineOffset: 'inherit',
		}}
	>
		{address}
	</ExternalLink>
);

export default LocationAddressLink;
